import { EnvironmentHelper } from "@repo/helpers";
import { ReactQueryDevtoolsPanel } from "@tanstack/react-query-devtools";
import { useState, type FC } from "react";
import { FloatingDevtoolsDialog } from "./FloatingDevtoolsDialog";
import { FloatingButton } from "./ReactQueryDevtoolsGate.styled";

export const ReactQueryDevtoolsGate: FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    if (EnvironmentHelper.isProd()) {
        return null;
    }

    return (
        <>
            <FloatingButton
                type="button"
                onClick={() => {
                    setIsOpen(!isOpen);
                }}
            >{`${isOpen ? "Close" : "Open"} React-Query-Devtools`}</FloatingButton>
            <FloatingDevtoolsDialog
                open={isOpen}
                onClose={() => {
                    setIsOpen(false);
                }}
            >
                <ReactQueryDevtoolsPanel
                    onClose={() => {
                        setIsOpen(false);
                    }}
                    style={{
                        height: "100%",
                    }}
                />
            </FloatingDevtoolsDialog>
        </>
    );
};
